import React, { useEffect } from 'react';
import { X } from 'lucide-react';
import { INGREDIENT_GLOSSARY } from '../utils/ingredientGlossary';

export default function IngredientGlossarySheet({ entryId, onClose }) {
  const entry = INGREDIENT_GLOSSARY[entryId];

  useEffect(() => {
    if (!entry) return undefined;
    const onKeyDown = (event) => { if (event.key === 'Escape') onClose(); };
    window.addEventListener('keydown', onKeyDown);
    return () => window.removeEventListener('keydown', onKeyDown);
  }, [entry, onClose]);

  if (!entry) return null;
  return (
    <div className="fixed inset-0 z-[80] flex items-end justify-center" role="presentation">
      <button type="button" className="absolute inset-0 bg-[#1C243A]/35" aria-label="Close ingredient guide" onClick={onClose} />
      <section role="dialog" aria-modal="true" aria-label={`About ${entry.name}`} className="relative w-full max-w-[430px] max-h-[85dvh] overflow-y-auto rounded-t-[28px] bg-white px-5 pt-3 pb-[max(24px,env(safe-area-inset-bottom))] shadow-2xl">
        <div className="mx-auto mb-5 h-1 w-10 rounded-full bg-[#2A324B]/20" />
        <div className="flex items-start justify-between gap-4">
          <div>
            <p className="text-[12px] font-semibold uppercase tracking-[0.15em] text-[#2A324B]/50">Ingredient guide</p>
            <h2 className="mt-1 text-[22px] font-semibold leading-tight text-[#2A324B]">{entry.name}</h2>
            <p className="mt-1 text-[13px] text-[#2A324B]/55">On the label: {entry.inci}</p>
          </div>
          <button type="button" onClick={onClose} aria-label="Close" className="flex h-11 w-11 flex-none items-center justify-center rounded-full bg-[#F4F1ED] text-[#2A324B]"><X className="h-5 w-5" /></button>
        </div>
        <div className="mt-5 space-y-4 text-[15px] leading-relaxed text-[#2A324B]">
          <p><strong className="font-semibold">What it is</strong><br />{entry.what}</p>
          <p><strong className="font-semibold">What it does</strong><br />{entry.does}</p>
          <p className="border-l-[3px] border-[#C8956A] pl-3 text-[#2A324B]/75"><strong className="font-semibold">Keep in mind</strong><br />{entry.nuance}</p>
        </div>
        <a href={entry.sourceUrl} target="_blank" rel="noopener noreferrer" className="mt-5 inline-block text-[13px] font-medium text-[#2A324B] underline underline-offset-2">Source: {entry.sourceLabel}</a>
      </section>
    </div>
  );
}
